import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-crear-operacion-cuenta',
  templateUrl: './crear-operacion-cuenta.component.html',
  styleUrls: ['./crear-operacion-cuenta.component.scss']
})
export class CrearOperacionCuentaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
